import { VertexBuffer } from "../Object/VertexBuffer";
import { ITexture } from "../Texture";
import { MeshLayout, Mesh } from "./Mesh";
import { RenderObject } from "../Object/RenderObject";
import { Context } from "../Engine";

export class PreCompiledGeometryMesh extends Mesh {
    public buffer: VertexBuffer;
    public texture: ITexture;
    public dataLayout: MeshLayout;

    public bufferMesh(data: Float32Array, vertexLength: number, vertexCount: number, texture?: ITexture) {
        let gl = this.ctx.gl;

        this.dataLayout = {
            position: { offset: 0, length: 3 },
            normal: { offset: 3, length: 3 },
            diffuseTexture: { offset: 6, length: 2 },
            staticLight: { offset: 8, length: 3 }
        };

        let glVertexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, glVertexBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);

        this.buffer = new VertexBuffer(glVertexBuffer, gl.TRIANGLES, vertexLength, vertexCount);

        this.texture = texture;
    }

    public createInstance(ctx: Context): RenderObject {
        return new RenderObject(this);
    }

}